module.exports = __webpack_public_path__ + "1125ba0b09f468e39dfcf07ce234b383.png";